import { MemoryRouter } from "react-router-dom";

// eslint-disable-next-line no-restricted-imports
import AppInitializer from "./AppInitializer";

function App() {
  return (
    <MemoryRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <AppInitializer />
    </MemoryRouter>
  );
}

export default App;
